import React from 'react';
import PropTypes from 'prop-types';

import { faTags } from '@fortawesome/pro-solid-svg-icons';

import { connect } from 'react-redux';
import { getCurrentTab } from '../store/selectors/ui';

import CompsViewToggle from '../comps_view_toggle';
import Controls from './controls';
import PageHeader from 'components/page_header';

export class CompsPageHeader extends React.Component {
  static propTypes = {
    currentPage: PropTypes.number.isRequired,
    currentTab: PropTypes.oneOf(['lease', 'sale']).isRequired,
    leases: PropTypes.array.isRequired,
    pageSize: PropTypes.number.isRequired,
    sales: PropTypes.array.isRequired,
    totalCount: PropTypes.number.isRequired,
  };

  render() {
    const {
      currentPage,
      currentTab,
      pageSize,
      leases,
      sales,
      totalCount,
    } = this.props;

    const compsSize = currentTab === 'lease' ? leases.length : sales.length;
    const pageData = {
      currentPage: currentPage,
      itemCount: compsSize,
      itemSingularLabel: 'comp',
      pageSize: pageSize,
      totalCount: totalCount
    };

    return (
      <PageHeader
        iconDescription="Manage your Comps"
        iconName={faTags}
        iconSize="lg"
        iconText="Comps"
        iconType="icon"
        pageData={pageData}
      >
        <div className="top-bar">
          <CompsViewToggle />
          <Controls/>
        </div>
      </PageHeader>
    );
  }
}

const mapStateToProps = state => ({
  ...state.search.meta,

  currentTab: getCurrentTab(state),
  leases: state.search.leases,
  sales: state.search.sales,
});

export default connect(mapStateToProps)(CompsPageHeader);
